import { MIN_DOCUMENT_SIZE, MAX_DOCUMENT_SIZE } from './constants';

export const isValidDocument = identityCard => {
  if (
    identityCard.length >= MIN_DOCUMENT_SIZE.AR &&
    identityCard.length <= MAX_DOCUMENT_SIZE.AR
  ) {
    return true;
  }
  return false;
};
